import request from "@/utils/request";
import Qs from "qs";

// 图片上传Oss（可多文件上传）
export function ossUpload(data) {
  return request({
    url: "/common/admin_oss_upload",
    method: "post",
    // ContentType:'multipart/form-data',
    data: Qs.stringify(data),
  });
}

// 获得阿里云短信配置详情
export function getMeconf(data) {
  return request({
    url: "/conf/get_meconf",
    method: "get",
    data: Qs.stringify(data),
  });
}

// 修改阿里云短信配置
export function setMessage(data) {
  return request({
    url: "/conf/set_message",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 隐私协议配置详情
export function getPrivacy(data) {
  return request({
    url: "/conf/get_privacy",
    method: "get",
    data: Qs.stringify(data),
  });
}

// 修改隐私协议配置
export function setPrivacy(data) {
  return request({
    url: "/conf/set_privacy",
    method: "post",
    data: Qs.stringify(data),
  });
}

// App推送配置详情
export function getPush(data) {
  return request({
    url: "/conf/get_push",
    method: "get",
    data: Qs.stringify(data),
  });
}

// 修改APP推送配置
export function setPush(data) {
  return request({
    url: "/conf/set_push",
    method: "post",
    data: Qs.stringify(data),
  });
}

// APP更新配置详情
export function getAppUp(data) {
  return request({
    url: "/conf/get_app_update",
    method: "get",
    data: Qs.stringify(data),
  });
}

// 修改APP更新配置
export function setAppUp(data) {
  return request({
    url: "/conf/set_app_update",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 设置国定假期
export function setHoliday(data) {
  return request({
    url: "/conf/set_national_holiday",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取国定假期
export function getHoliday(data) {
  return request({
    url: "/conf/get_national_holiday",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件厂商列表
export function manufacturer_list(data) {
  return request({
    url: "/system/manufacturer_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加硬件厂商
export function manufacturer_add(data) {
  return request({
    url: "/system/manufacturer_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑硬件厂商
export function manufacturer_edit(data) {
  return request({
    url: "/system/manufacturer_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 查看硬件厂商
export function manufacturer_info(data) {
  return request({
    url: "/system/manufacturer_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除硬件厂商
export function manufacturer_del(data) {
  return request({
    url: "/system/manufacturer_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 硬件列表
export function hardware_list(data) {
  return request({
    url: "/system/hardware_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加硬件
export function hardware_add(data) {
  return request({
    url: "/system/hardware_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑硬件
export function hardware_edit(data) {
  return request({
    url: "/system/hardware_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 查看硬件
export function hardware_info(data) {
  return request({
    url: "/system/hardware_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除硬件
export function hardware_del(data) {
  return request({
    url: "/system/hardware_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 园区硬件配置列表
export function HMP_rel_list(data) {
  return request({
    url: "/system/hardware_manufacturer_park_rel_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加园区硬件配置
export function HMP_rel_add(data) {
  return request({
    url: "/system/hardware_manufacturer_park_rel_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑园区硬件配置
export function HMP_rel_edit(data) {
  return request({
    url: "/system/hardware_manufacturer_park_rel_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 查看园区硬件配置
export function HMP_rel_info(data) {
  return request({
    url: "/system/hardware_manufacturer_park_rel_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除园区硬件配置
export function HMP_rel_del(data) {
  return request({
    url: "/system/hardware_manufacturer_park_rel_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 通过硬件ID获取厂商列表
export function getIdHardware(data) {
  return request({
    url: "/common/get_manufacturer_list_by_hardware_id",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 获取园区未绑定的硬件
export function get_usable_hardware_lists(data) {
  return request({
    url: "/common/get_usable_hardware_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 初始化三深国际中心的企业数据
export function san_shen_company(data) {
  return request({
    url: "/init/san_shen_company",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 初始化三深国际中心的用户数据
export function san_shen_user(data) {
  return request({
    url: "/init/san_shen_user",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 设置僵尸车判定时间
export function set_zombie_vehicle_time(data) {
  return request({
    url: "/conf/set_zombie_vehicle_time",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 获取僵尸车判定时间
export function get_zombie_vehicle_time(data) {
  return request({
    url: "/conf/get_zombie_vehicle_time",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 通知模版列表
export function noticeLists(data) {
  return request({
    url: "/notice_template/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加通知模版
export function noticeAdd(data) {
  return request({
    url: "/notice_template/add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除通知模版
export function noticeDel(data) {
  return request({
    url: "/notice_template/del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看通知模版详情
export function noticeInfo(data) {
  return request({
    url: "/notice_template/info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑通知模版
export function noticeEdit(data) {
  return request({
    url: "/notice_template/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 通知模版列表
export function parkRelList(data) {
  return request({
    url: "/notice_template/park_rel_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加通知模版
export function parkRelAdd(data) {
  return request({
    url: "/notice_template/park_rel_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除通知模版
export function parkRelDel(data) {
  return request({
    url: "/notice_template/park_rel_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看通知模版详情
export function parkRelInfo(data) {
  return request({
    url: "/notice_template/park_rel_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑通知模版
export function parkRelEdit(data) {
  return request({
    url: "/notice_template/park_rel_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 获取通知管理模版
export function get_manage_templates(data) {
  return request({
    url: "/common/get_manage_templates",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 设置工位到期提醒时间（小时）
export function set_station_remind_time(data) {
  return request({
    url: "/conf/set_station_remind_time",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 初始化西溪创智的能耗
export function init_energy(data) {
  return request({
    url: "/init/init_energy",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 同步公众号用户
export function get_user_openid_by_gong_zhong_hao(data) {
  return request({
    url: "/conf/get_user_openid_by_gong_zhong_hao",
    method: "post",
    data: Qs.stringify(data),
  });
}